import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(private http: HttpClient) {}

  private redirectToCognitoLogin(): void {
    window.location.href = environment.cognitoUrl; 
  }

  getTokens(code: string): Observable<any> {
    const body = new HttpParams()
      .set('grant_type', 'authorization_code')
      .set('client_id', environment.clientId)
      .set('code', code)
      .set('redirect_uri', environment.redirectUri)
      .set('client_secret', environment.clientSecret);
  
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded');
  
    return this.http.post(environment.tokenUrl, body.toString(), { headers });
  }

  revokeToken(token: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic YzJyYTM5Z2Vwb21kbmhsNTZqaDdnb2NmbToxNXJjZ2UyZWFwcnE3bjN0NGdsNXQzZTRqcXZocDkwOWxlbjVkdG5ibWZ1N2pjZ3B2cGg1',
    });

    const body = new URLSearchParams();
    body.set('client_id', environment.clientId);
    body.set('token', token);

    this.http.post(environment.cognitoRevokeUrl, body.toString(), { headers })
      .subscribe(response => {
        this.redirectToCognitoLogin();
        console.log('Token revocado y redirigiendo al login de Cognito');
      }, error => {
        console.error('Error al revocar el token:', error);
      });
  }



  getEntidadPorDocumento(docType: string, docNumber: string): Observable<any> {
    const headers = new HttpHeaders({
      'message-id': crypto.randomUUID(),
      'entity-doc-type': docType,
      'entity-doc-number': docNumber,
    });

    return this.http.get(environment.entityByDocumentUrl, { headers });
  }

  getFirmantesPorEntidad(docType: string, docNumber: string): Observable<any> {
    const headers = new HttpHeaders({
      'message-id': crypto.randomUUID(),
      'entity-doc-type': docType,
      'entity-doc-number': docNumber,
    });

    return this.http.get(environment.signersByEntityUrl, { headers });
  }

  getUsuarioPorDocumento(docType: string, docNumber: string, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'message-id': crypto.randomUUID(),
      'user-doc-type': docType,
      'user-doc-number': docNumber,
    });

    return this.http.get(environment.userUrl, { headers });
  }

  actualizarUsuario(docType: string, docNumber: string, userData: any): Observable<any> {
    const headers = new HttpHeaders({
      'message-id': crypto.randomUUID(),
      'user-doc-type': docType,
      'user-doc-number': docNumber,
    });

    return this.http.put(environment.userUrl, userData, { headers });
  }

  getDocumentosGenerados(docType: string, docNumber: string): Observable<any> {
    const headers = new HttpHeaders({
      'message-id': crypto.randomUUID(),
      'user-doc-type': docType,
      'user-doc-number': docNumber,
    });

    return this.http.get(environment.documentByUserUrl, { headers });
  }

  crearFirmante(firmanteData: any): Observable<any> {
    const headers = new HttpHeaders({
      'message-id': crypto.randomUUID(),

    });

    return this.http.post(environment.signerUrl, firmanteData, { headers });
  }

  getFirmantePorId(signerId: number, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'message-id': crypto.randomUUID(),
      'signer-id': signerId.toString(),
    });
  
    return this.http.get(environment.signerUrl, { headers });
  }

  updateFirmante(firmanteData: any): Observable<any> {
    const headers = new HttpHeaders({
      'message-id': crypto.randomUUID(),
    });

    return this.http.put(environment.signerUrl, firmanteData, { headers });
  }

  deleteFirmante(signerId: number): Observable<any> {
    const headers = new HttpHeaders({
      'message-id': crypto.randomUUID(),
      'signer-id': signerId.toString(),
      'api-key': 'fe4f35bb-8880-4f66-bee9-57584146e0ff'
    });
  

    return this.http.delete(environment.signerUrl, { headers });
  }
  
  



}
